import { AnimatePresence, motion } from 'framer-motion';
import { IconCheck, IconX, IconInfoCircle, IconAlertTriangle } from '@tabler/icons-react';
import { useToastStore, type ToastKind } from '../../state/toastStore.ts';
import { cn } from '../../lib/cn.ts';

const ICONS: Record<ToastKind, typeof IconCheck> = {
  success: IconCheck,
  error: IconAlertTriangle,
  info: IconInfoCircle,
};

const ACCENT: Record<ToastKind, string> = {
  success: 'text-emerald-400',
  error: 'text-rose-400',
  info: 'text-sky-400',
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-full max-w-sm flex-col gap-2">
      <AnimatePresence initial={false}>
        {toasts.map((t) => {
          const Icon = ICONS[t.kind];
          return (
            <motion.div
              key={t.id}
              layout
              initial={{ opacity: 0, y: 16, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, x: 24 }}
              transition={{ duration: 0.2 }}
              className="border border-line bg-surface shadow-md pointer-events-auto flex items-start gap-3 rounded-2xl p-3 pr-2"
              role="alert"
            >
              <Icon className={cn('mt-0.5 h-5 w-5 shrink-0', ACCENT[t.kind])} />
              <p className="flex-1 text-sm text-fg">{t.message}</p>
              <button
                onClick={() => dismiss(t.id)}
                className="rounded-lg p-1 text-muted hover:bg-grid"
                aria-label="Dismiss notification"
              >
                <IconX className="h-4 w-4" />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
